import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getLcn } from '~/utils/labeled-classnames';

export default function MenuLink({
  icon,
  to,
  children,
  onCLick,
  className,
  endIcon,
  blank,
}: {
  icon: React.ReactNode
  endIcon?: React.ReactNode
  to?: string
  children: React.ReactNode
  onCLick?: () => void
  className?: string
  blank?: boolean
}) {

  const { pathname } = useLocation();
  const active = pathname === to;

  //console.log({ pathname, to });

  const lcn = getLcn({
    menuLink: [
      'flex items-start justify-between py-2 px-3 rounded-[0px 5px 5px 0px] w-full ',
      'hover:bg-black/5 dark:hover:bg-white/10',
      className,
      active ? 'bg-black/5 dark:bg-white/5 ' : ''
    ],
  });

  const content = <>
    <div className='flex items-start gap-3'>
      <div className='leading-none'>
        {icon}
      </div>
      <div className='text-left'>
        <div className='-mt-1 leading-normal '> {children}</div>
      </div>
    </div>
    {endIcon &&
      <div className='leading-none'>
        {endIcon}
      </div>
    }
  </>

  if (onCLick) {
    return (
      <button className={lcn.menuLink} onClick={onCLick}>
        {content}
      </button>
    );
  }

  if (to) {
    if (blank) {
      return (
        <a className={lcn.menuLink} href={to} target="_blank" rel="noopener noreferrer">
          {content}
        </a>
      );
    }
    return (
      <Link className={lcn.menuLink} to={to}>
        {content}
      </Link>
    );
  }
}; 